// extracted by mini-css-extract-plugin
export default {"heading":"InvestmentDocuments_heading__oOfsR","download":"InvestmentDocuments_download__ctIGH","root":"InvestmentDocuments_root__-5RQu","card":"InvestmentDocuments_card__RcwXz"};